module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-bg"
  }, [_c('div', {
    staticClass: "bg-image"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-blur"
  }), _vm._v(" "), _c('div', {
    staticClass: "login-card"
  }, [_c('div', {
    staticClass: "login-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "app-info"
  }, [_c('div', {
    staticClass: "app-name"
  }, [_vm._v("\n          " + _vm._s(_vm.appName) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "app-meta"
  }, [_c('span', {
    staticClass: "app-version"
  }, [_vm._v("v" + _vm._s(_vm.appVersion))]), _vm._v(" "), (_vm.isDev) ? _c('span', {
    staticClass: "app-dev"
  }, [_vm._v("DEV")]) : _vm._e()])])]), _vm._v(" "), _c('Form', {
    ref: "formInline",
    staticClass: "login-form",
    attrs: {
      "model": _vm.formInline,
      "rules": _vm.ruleInline
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "username"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "Username",
      "size": "large"
    },
    model: {
      value: (_vm.formInline.username),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "username", $$v)
      },
      expression: "formInline.username"
    }
  }, [_c('Icon', {
    attrs: {
      "slot": "prepend",
      "type": "ios-person-outline"
    },
    slot: "prepend"
  })], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "placeholder": "Password",
      "size": "large"
    },
    on: {
      "on-enter": function($event) {
        return _vm.handleSubmit('formInline')
      }
    },
    model: {
      value: (_vm.formInline.password),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "password", $$v)
      },
      expression: "formInline.password"
    }
  }, [_c('Icon', {
    attrs: {
      "slot": "prepend",
      "type": "ios-locked-outline"
    },
    slot: "prepend"
  })], 1)], 1), _vm._v(" "), _c('Form-item', [_c('Button', {
    staticClass: "login-btn",
    attrs: {
      "long": "",
      "loading": _vm.loadingLogin,
      "icon": "log-in"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formInline')
      }
    }
  }, [(!_vm.loadingLogin) ? _c('span', [_vm._v("Login")]) : _c('span', [_vm._v("Authenticating...")])])], 1)], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-animated"
  }, [_c('img', {
    staticClass: "logo-img",
    attrs: {
      "src": "/static/login-logo.png",
      "alt": "BRweb Logo"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "logo-shine"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e95d8a4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/Login.vue
// module id = 1784
// module chunks = 1